import React from 'react';
import PropTypes from 'prop-types';

import {CircularProgress} from "@mui/material";

import CustomButton from "components/CustomButton";
import Badge from "components/Badge";

import {black500, greyishBlue500} from "assets/jss/main";

MobileStatusTab.propTypes = {
    label: PropTypes.node,
    count: PropTypes.number,
    theme: PropTypes.string,
    badgeTextColor: PropTypes.string,
    dotColor: PropTypes.string,
    selected: PropTypes.bool,
    onClick: PropTypes.func,
    loading: PropTypes.bool
};


function MobileStatusTab({label, count = 0, theme, badgeTextColor, dotColor, selected = false, onClick, loading = false}) {
    return (
        <CustomButton
            color="default"
            variant="outlined"
            thicker
            rounded
            noBorder={!selected}
            onClick={onClick}
            sx={{
                flexShrink: 0,
                backgroundColor: selected ? '#fff' : '#f5f5f5',
                borderColor: selected ? black500 : 'transparent'
            }}
        >
            <div style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                <span style={{width: '6px', height: '6px', borderRadius: '50%', backgroundColor: dotColor, flexShrink: 0}} />
                <span style={{fontSize: '14px', fontWeight: 600, color: selected ? black500 : greyishBlue500, whiteSpace: 'nowrap'}}>
                    {label}
                </span>
                <Badge
                    color={selected ? theme : 'archived'}
                    labelColor={selected ? (badgeTextColor ?? theme) : greyishBlue500}
                >
                    {loading ? <CircularProgress size={10} color={'inherit'} /> : count}
                </Badge>
            </div>
        </CustomButton>
    );
}

export default MobileStatusTab;
